import React from "react";

const TransitionMs = 300;

const useHeightTransition = (ref: React.RefObject<HTMLElement>, trigger: unknown) => {
  const previousHeight = React.useRef<number>();

  React.useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const from = previousHeight.current;
    const to = element.offsetHeight;
    previousHeight.current = to;
    if (from === undefined || from === to) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    element.style.height = `${from}px`;
    element.style.transition = "none";
    element.getBoundingClientRect();
    element.style.transition = `height ${TransitionMs}ms cubic-bezier(0.2, 0.7, 0.2, 1)`;
    element.style.height = `${to}px`;

    const done = () => {
      element.style.height = "";
      element.style.transition = "";
    };
    element.addEventListener("transitionend", done, { once: true });
    const fallback = window.setTimeout(done, TransitionMs + 150);
    return () => {
      element.removeEventListener("transitionend", done);
      window.clearTimeout(fallback);
      done();
    };
  }, [ref, trigger]);
};

export default useHeightTransition;
